export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref12852.6472fc68.jpg";